import { useQuery } from "react-query";
import http from "shared/http";

export interface SiteSearchItem {
  id: number;
  name: string;
  summary?: string | null;
  url?: string | null;
  categoryId?: number | null;
}

export interface SiteSearchResult {
  categories: SiteSearchItem[];
  reports: SiteSearchItem[];
  links: SiteSearchItem[];
  downloads: SiteSearchItem[];
  pages: SiteSearchItem[];
}

export const useSiteSearchQuery = (query: string) =>
  useQuery(
    ["site-search", query],
    async (): Promise<SiteSearchResult> =>
      http.fetchAsync(`resource/search?q=${encodeURIComponent(query)}`),
    {
      enabled: query.trim().length >= 2,
      staleTime: 30 * 1000,
      keepPreviousData: true,
    },
  );
